module.exports = __webpack_public_path__ + "static/media/tick-green.7e5ed075.svg";